module.exports = __webpack_public_path__ + "static/img/img2.466b102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/znfp2021/img2.jpg
// module id = se2j
// module chunks = 0